import { GraphQLID, isInputType, GraphQLString, GraphQLBoolean, GraphQLFloat, GraphQLInt, } from 'graphql';
import { stringInterpolator } from './string-interpolator';
import { Headers } from 'cross-fetch';
export var ArgType;
(function (ArgType) {
    ArgType["ID"] = "ID";
    ArgType["String"] = "String";
    ArgType["Boolean"] = "Boolean";
    ArgType["Float"] = "Float";
    ArgType["Int"] = "Int";
})(ArgType || (ArgType = {}));
export function getInputTypeFromTypeName(typeName) {
    if (isInputType(typeName)) {
        return typeName;
    }
    else {
        switch (typeName) {
            case ArgType.ID:
                return GraphQLID;
            case ArgType.String:
                return GraphQLString;
            case ArgType.Boolean:
                return GraphQLBoolean;
            case ArgType.Float:
                return GraphQLFloat;
            case ArgType.Int:
                return GraphQLInt;
        }
    }
}
export function parseInterpolationStrings(interpolationStrings, argTypeMap) {
    const interpolationKeys = interpolationStrings.reduce((keys, str) => [...keys, ...(str ? stringInterpolator.parseRules(str).map((match) => match.key) : [])], []);
    const args = {};
    const contextVariables = [];
    for (const interpolationKey of interpolationKeys) {
        const interpolationKeyParts = interpolationKey.split('.');
        const varName = interpolationKeyParts[interpolationKeyParts.length - 1];
        if (interpolationKeyParts[0] === 'args') {
            const argType = argTypeMap && varName in argTypeMap ? getInputTypeFromTypeName(argTypeMap[varName]) : GraphQLID;
            args[varName] = {
                type: argType,
            };
        }
        else if (interpolationKeyParts[0] === 'context') {
            contextVariables.push(varName);
        }
    }
    return {
        args,
        contextVariables,
    };
}
export function getInterpolatedStringFactory(nonInterpolatedString) {
    return resolverData => stringInterpolator.parse(nonInterpolatedString, resolverData);
}
export function getInterpolatedHeadersFactory(nonInterpolatedHeaders = {}) {
    return resolverData => {
        const headers = new Headers();
        for (const headerName in nonInterpolatedHeaders) {
            const headerValue = nonInterpolatedHeaders[headerName];
            if (headerValue) {
                headers.set(headerName, stringInterpolator.parse(headerValue, resolverData));
            }
        }
        return headers;
    };
}
export function getHeadersObject(headers) {
    const headersObj = {};
    headers.forEach((value, key) => {
        headersObj[key] = value;
    });
    return headersObj;
}
//# sourceMappingURL=resolver-data-factory.js.map